// Drawer / menu title of a create form, from the one language table (47071): const ct = useCreateTitle(); ct('production') / ct('payment', { subtype: 'Supplier Payment' })
import { useTranslation } from 'react-i18next';
import { createTitleRef } from './createMenuModel.mjs';
export default function useCreateTitle() {
  const { t } = useTranslation();
  return (id, params) => t(createTitleRef(id, params));
}
